import { Client } from '../types';

export const clients: Client[] = [
  {
    id: 1,
    name: 'Windsurf',
    logo: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748523643/Codeium_Logo_uhiiqg.svg',
    industry: 'AI Development Tools',
    website: 'https://windsurf.com/'
  },
  {
    id: 2,
    name: 'Ansys',
    logo: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748521488/ANSYS_Logo_jzb5pv.png',
    industry: 'Engineering Simulation',
    website: 'https://ansys.com'
  },
  {
    id: 3,
    name: 'CS First',
    logo: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748522368/CSFirst_Logo_dt8zwb.jpg',
    industry: 'Customer Success',
    website: 'https://www.csfirst.ai/'
  },
  {
    id: 4,
    name: 'Canoga Perkins',
    logo: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748522575/Canoga_Perkins_Corp_Logo_a1ew4j.jpg',
    industry: 'Network Infrastructure',
    website: 'https://www.canogaperkins.net/'
  },
  {
    id: 5,
    name: 'Rackware',
    logo: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748522132/rackware_zdmlvp.jpg',
    industry: 'Cloud Migration',
    website: 'https://rackware.com'
  },
  {
    id: 6,
    name: 'Nile Secure',
    logo: 'https://res.cloudinary.com/dttkz0pie/image/upload/v1748522795/Nile_Secure_Logo_tlnrmc.jpg',
    industry: 'Cybersecurity',
    website: 'https://nilesecure.com'
  },
];